export const ONBOARDING_PENDING_PREFIX = 'prode:onboarding:pending:';
export const ONBOARDING_SEEN_PREFIX = 'prode:onboarding:seen:';

// id opcional: si se omite, usa las claves legacy (el onboarding original de bienvenida).
const withId = (id) => (id ? `${id}:` : '');

export const getOnboardingPendingKey = (userId, id) =>
  `${ONBOARDING_PENDING_PREFIX}${withId(id)}${userId}`;

export const getOnboardingSeenKey = (userId, id) =>
  `${ONBOARDING_SEEN_PREFIX}${withId(id)}${userId}`;

const resolveStorage = (storage) =>
  storage || (typeof window !== 'undefined' ? window.localStorage : null);

export const getOnboardingPending = (userId, id, storage) => {
  const s = resolveStorage(storage);
  return !!s && s.getItem(getOnboardingPendingKey(userId, id)) === '1';
};

export const getOnboardingSeen = (userId, id, storage) => {
  const s = resolveStorage(storage);
  return !!s && !!s.getItem(getOnboardingSeenKey(userId, id));
};

export const markOnboardingPendingIfNeeded = (userId, id, storage) => {
  const s = resolveStorage(storage);
  if (!userId || !s) return;
  if (!s.getItem(getOnboardingSeenKey(userId, id))) {
    s.setItem(getOnboardingPendingKey(userId, id), '1');
  }
};

export const markOnboardingSeen = (userId, id, storage) => {
  const s = resolveStorage(storage);
  if (!userId || !s) return;
  s.setItem(getOnboardingSeenKey(userId, id), '1');
  s.removeItem(getOnboardingPendingKey(userId, id));
};
